import { SVGProps } from 'react';

export const RangeOperatorLessThan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="15"
    viewBox="0 -2 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 4.25391V6.43262L9.90625 10.6973V8.02637L2.78906 5.32617L9.90625 2.67188V0L0 4.25391Z"
      fill="currentColor"
    />
  </svg>
);
